let preventToggle = false;
function adjustSidebarDetailsHeight(element) {
  if (element.open) {
    const summaryHeight = element.querySelector('summary').offsetHeight;
    const siblingHeight = element.querySelector('summary').nextElementSibling.offsetHeight;
    element.style.minHeight = summaryHeight + siblingHeight + 'px';
  } else {
    element.style.minHeight = '';
  }
}
function closeSiblingDetails(element) {
  const siblingParents = element.parentElement.parentElement.children;
  const siblingDetails = Array.from(siblingParents).filter((sibelement) => 
    sibelement.firstElementChild.tagName === 'DETAILS' && 
    sibelement.firstElementChild !== element && 
    sibelement.firstElementChild.open
  );
  siblingDetails.forEach((siblingDetail) => {
    const sibling = siblingDetail.firstElementChild;
    preventToggle = true;
    sibling.open = false;
    adjustSidebarDetailsHeight(sibling);
    setTimeout(() => {
      preventToggle = false;
    }, 100);
  });
}
function handleDetailClick(event) {
  if (preventToggle) return;
  const element = event.currentTarget;
  closeSiblingDetails(element);
  adjustSidebarDetailsHeight(element);
  const parentDetails = element.parentElement.parentElement.parentElement.parentElement.parentElement;
  if (parentDetails.tagName === 'DETAILS') {
    setTimeout(() => adjustSidebarDetailsHeight(parentDetails), 300);
  }
}
document.querySelectorAll('.has-submenu details').forEach((element) => {
  element.addEventListener('toggle', handleDetailClick);
});